import zafClient, {getMetadata} from './zendesk'
const PROXY_URL = "https://proxyintegration.bcrcx.com/vtex"
let VTEX_COMMERCE_URL = ""
let VTEX_CRM_URL = ""

const headers = {
    "X-VTEX-API-AppKey": "{{setting.vtexAppKey}}",
    "X-VTEX-API-AppToken": "{{setting.vtexAppToken}}",
    "ngrok-skip-browser-warning": "69420",  
}

getMetadata().then(metadata => {
 VTEX_CRM_URL = `https://api.vtexcrm.com.br/${metadata.settings.vtexAppSubdominio}`
 VTEX_COMMERCE_URL = `https://${metadata.settings.vtexAppSubdominio}.vtexcommercestable.com.br`
})

async function getUserEmail(profileId, headers) {
  const url = `${VTEX_CRM_URL}/dataentities/CL/search?_fields=email&_where=userId=${profileId}`
  return await zafClient.request({
    method: 'GET',
    secure: true,
    url: PROXY_URL,
    headers: {... headers, "BCR-PROXY-VTEX-URL": url}
  })
}

async function _getOrder(orderId) {
  return await zafClient.request({
    url: PROXY_URL,
    secure: true,
    method: 'GET',
    headers: {... headers, "BCR-PROXY-VTEX-URL": `${VTEX_COMMERCE_URL}/api/oms/pvt/orders/${orderId}`}
  })
}

export async function getOrder(orderId) {
    const orderRequest = await _getOrder(orderId)

    // Recupera o endereço de email não mascarado, se permitido
    const profileId = orderRequest.clientProfileData.userProfileId
    try { 
      const searchResults = await getUserEmail(profileId)
      if (searchResults.length > 0) {
        orderRequest.clientProfileData.email = searchResults[0].email
      }
    } 
    catch (e){
      console.error("vtex:", e)
    }
    return orderRequest
}

export async function getOrders(query, shoeIncomplete = false) {
    const url = `${VTEX_COMMERCE_URL}/api/oms/pvt/orders`
    return await zafClient.request({
      url: PROXY_URL,
      method: 'GET',
      secure: true,
      headers: {... headers, "BCR-PROXY-VTEX-URL": `${url}?q=${query}&incompleteOrders=${shoeIncomplete}`}
    })
  }

  export async function getOrderConversations(orderId) {
    const url = `${VTEX_COMMERCE_URL}/api/oms/pvt/orders/${orderId}/conversation-message`

    const resp = await zafClient.request({
        url: PROXY_URL,
        method: 'GET',
        secure: true,
        headers: {... headers, "BCR-PROXY-VTEX-URL": url}
    })

    return resp
}